import {Component, inject, ChangeDetectionStrategy} from '@angular/core';
import {LocalStorageService} from '../_services/local-storage.service';
import {Community} from '../_types/communities';

@Component({
    selector: 'app-terms',
    templateUrl: './terms.component.html',
    styleUrl: './terms.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TermsComponent {
    private readonly localStorageService: LocalStorageService = inject(LocalStorageService);

    get lastSelectedCommunity(): Community | null {
        return this.localStorageService.getItem<Community | null>('lastSelectedCommunity', null);
    }
}
